/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     AlertPanel.js
//   Details:    AlertPanel.js
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 105066 06/01/20 JC  M01  Added font awesome
// WI3713 30/01/24 JC  M02JC	Handled multi-line alerts
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//M01 import { Glyphicon } from 'react-bootstrap';
import './css/AlertPanel.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M01
import { Col, Row } from 'react-bootstrap'; //M02JC

class AlertPanel extends Component {
	constructor(props) {
		super(props);

		this.handleClear = this.handleClear.bind(this);
	}

	handleClear = event => {
		event.preventDefault();
		if (typeof this.props.clear === "function") {
			this.props.clear();
		}
	}

	render() {
		const { type, message, clear } = this.props;
		const hasClear = typeof clear === "function";

		return(
			<div className={`alert alert-${type}`}>
                {type === "danger" ? <FontAwesomeIcon className="alert-icon" size="lg" icon="exclamation-circle" /> : [] /*M01*/}
                {type === "info" ? <FontAwesomeIcon className="alert-icon" size="lg" icon="info-circle" /> : [] /*M01*/}
                {type === "success" ? <FontAwesomeIcon className="alert-icon" size="lg" icon="check" /> : [] /*M01*/}
                {type === "pending" ? <FontAwesomeIcon className="alert-icon" size="lg" icon="clock" /> : [] /*M01*/}				
				<Col sm={12}> {/*M02JC*/}
					{message.split("\n").map((splitMessage, k) => {
						return (
							<Row key={`n${k}`}>{splitMessage}</Row> /*M02JC*/
						)
					})}
				</Col>
				{hasClear
                    ? <a className="btn push-right" onClick={this.handleClear}><FontAwesomeIcon icon="times" /></a> /*M01*/
					: []}
			</div >
		);
	}
}

AlertPanel.propTypes = {
	type: PropTypes.oneOf(['danger', 'info', 'success', 'pending']),
	message: PropTypes.string.isRequired,
	clear: PropTypes.func
};


export default connect(
	state => state
)(AlertPanel);
